import type {RouteRecordRaw} from 'vue-router';

import airflowController from '@/services/controllers/airflow';
import {datasourceController} from '@/services/controllers/datasource';
import roleController from '@/services/controllers/role';
import userController from '@/services/controllers/user';
import webhookController from '@/services/controllers/webhook';

export const adminPageRoutes: Array<RouteRecordRaw> = [
  {
    path: 'users',
    name: 'AdminUsersPage',
    meta: {
      menu: {
        name: userController.fieldNames.pageTitle,
      },
    },
    component: () => import('@/app/admin/pages/AdminUsersPage.vue'),
  },
  {
    path: 'roles',
    name: 'AdminRolesPage',
    meta: {
      menu: {
        name: roleController.fieldNames.pageTitle,
      },
    },
    component: () => import('@/app/admin/pages/AdminRolesPage.vue'),
  },
  {
    path: 'airflows',
    name: 'AdminAirflowsPage',
    meta: {
      menu: {
        name: airflowController.fieldNames.pageTitle,
      },
    },
    component: () => import('@/app/admin/pages/AdminAirflowsPage.vue'),
  },
  {
    path: 'datasources',
    name: 'AdminDatasourcesPage',
    meta: {
      menu: {
        name: datasourceController.fieldNames.pageTitle,
      },
    },
    component: () => import('@/app/admin/pages/AdminDatasourcesPage.vue'),
  },
  {
    path: 'webhooks',
    name: 'AdminWebhooksPage',
    meta: {
      menu: {
        name: webhookController.fieldNames.pageTitle,
      },
    },
    component: () => import('@/app/admin/pages/AdminWebhooksPage.vue'),
  },
];
